import { TicketStatus } from '@rtkwlf/rendall';
import type { TFunction } from 'i18next';
import type { Resolver } from 'react-hook-form';

import { TicketTypeOption } from '@features/tickets/components/ticketList/filter/ticketFilters.constants';

export enum CloseAction {
  Close = 'close',
  Suppress = 'suppress',
  Request = 'request',
  ManageAlertConfiguration = 'manageAlertConfiguration',
}

export enum CommentAction {
  Comment = 'comment',
}

export type ActionType = CloseAction | CommentAction;

export type ValidationFnc = (t: TFunction) => Resolver;

export type OptionType = {
  value: ActionType;
  text: string;
};

export const generalActions = [
  { isForAll: true, value: CommentAction.Comment },
  {
    forType: TicketTypeOption.Incident,
    isForAll: false,
    value: CloseAction.Suppress,
  },
  {
    forType: TicketTypeOption.Incident,
    isForAll: false,
    value: CloseAction.ManageAlertConfiguration,
  },
  { isForAll: true, value: CloseAction.Request },
  { isForAll: true, value: CloseAction.Close },
];

export const exclusiveStatuses: TicketStatus[] = [
  TicketStatus.Solved,
  TicketStatus.Closed,
];
export const exclusiveTypes = ['onboarding', 'provisioning'];
